import { FC } from 'react';
import Image from 'next/image';
import { CustomLink } from './SurpriseMenuFloatButton.style';
const SurpriseMenuFloatButton: FC = () => {
  return <CustomLink href={'/surprise-menu'}>
            <Image src={'/images/surprise-menu/float-button.png'} alt="surprise menu" width={100} height={120} />
        </CustomLink>;
};
export default SurpriseMenuFloatButton;